export default {
  common: {
    '登录/注册': '登录/注册',
    '首页': '首页',
    '新闻': '新闻',
    '方法': '方法',
    '数据': '数据',
    '团队': '团队',
    '关于': '关于',
    '联系': '联系',
    '免责声明': '免责声明',
    '联系我们': '联系我们',
    '注册协议': '注册协议',
    '隐私政策': '隐私政策',
    '版权所有©2023 保留所有权利': '版权所有©2023 保留所有权利',
    '客服电话': '客服电话',
    '工作时间': '工作时间',
    '官方邮箱': '官方邮箱',
    '扫码添加客服微信': '扫码添加客服微信',
    '扫码添加客服QQ': '扫码添加客服QQ',
    '提示': '提示',
    '请先登录在进行数据下载': '请先登录在进行数据下载',
    '取消': '取消',
    '确认': '确认',
    
    '登录': '登录',
    '注册': '注册',
    '退出': '退出',
    '请勿重复点击': '请勿重复点击',
    '搜索': '搜索',
    '重置': '重置',
    '确认退出当前账号？': '确认退出当前账号？',
    '欢迎来到intelligent carbon中国上市公司碳数据库': '欢迎来到intelligent carbon中国上市公司碳数据库',
    '忘记密码': '忘记密码',
    '账号登录': '账号登录',
    '注册账号': '注册账号',
    '请阅读并同意': '请阅读并同意',
    '和': '和',
    '请输入您的邮箱地址': '请输入您的邮箱地址',
    '请输入您的登录密码': '请输入您的登录密码',
    '验证码登录': '验证码登录',
    '忘记密码？': '忘记密码？',
    '手机号登录': '手机号登录',
    '请输入验证码': '请输入验证码',
    '获取验证码': '获取验证码',
    '验证码已发送，请注意查收': '验证码已发送，请注意查收',
    '密码登录': '密码登录',
    '重置成功，请使用新密码登录': '重置成功，请使用新密码登录',
    '请输入您的手机号': '请输入您的手机号',
    '邮箱地址格式不正确': '邮箱地址格式不正确',
    '手机号格式不正确': '手机号格式不正确',
    '请输入6-12位包含字母和数字的密码': '请输入6-12位包含字母和数字的密码',
    '邮箱登录': '邮箱登录',
    '请输入您的密码': '请输入您的密码',
    '请再次输入您的密码': '请再次输入您的密码',
    '请输入您的姓名': '请输入您的姓名',
    '请输入您的联系方式': '请输入您的联系方式',
    '请输入您的单位名称': '请输入您的单位名称',
    '请输入您的新密码': '请输入您的新密码',
    '请再次输入您的新密码': '请再次输入您的新密码',
    '两次密码不一致': '两次密码不一致',
    '确定': '确定',
    '返回登录': '返回登录',
    '手机号注册': '手机号注册',
    '邮箱注册': '邮箱注册',
    '我已阅读并同意': '我已阅读并同意',
    '您的认证审核已提交成功': '您的认证审核已提交成功',
    '您的申请已提交，1-3个工作日为您反馈审核结果': '您的申请已提交，1-3个工作日为您反馈审核结果',
    '返回首页': '返回首页',

    '查看详情': '查看详情',
    '新闻详情': '新闻详情',
    '团队详情': '团队详情',
    '数据下载': '数据下载',
    '下载失败，请重试': '下载失败，请重试',
    '按行业查询': '按行业查询',
    '按企业查询': '按企业查询',
    '按年份查询': '按年份查询',
    '请选择': '请选择',
    '展开筛选': '展开筛选',
    '收起筛选': '收起筛选',
    '选择的企业：': '选择的企业：',
    '总': '总',
    '未知': '未知',
    '二氧化碳': '二氧化碳',
    '年排放量（吨二氧化碳）': '年排放量（吨二氧化碳）',
    '企业每年总二氧化碳排放量': '企业每年总二氧化碳排放量',
    '行业每年总二氧化碳排放量': '行业每年总二氧化碳排放量',
    '年': '年',
    '总二氧化碳排放量': '总二氧化碳排放量',
    '吨': '吨',

    
    '暂无数据': '暂无数据',
    '操作成功': '操作成功',
    '充值': '充值',
    '积分': '积分',
    '设置': '设置',
    '已订阅': '已订阅',
    '暂未订阅': '暂未订阅',
    '立即订阅': '立即订阅',
    '立即续费': '立即续费',
    '积分充值': '积分充值',
    '积分余额': '积分余额',
    '自定义充值': '自定义充值',
    '支付': '支付',
    '微信': '微信',
    '支付宝': '支付宝',
    '立即充值': '立即充值',
    '请输入': '请输入',
    '订阅': '订阅',
    '月': '月',
    '确认协议并支付': '确认协议并支付',
    '本次下载需消耗': '本次下载需消耗',
    '立即下载': '立即下载',
    '个人资料': '个人资料',
    '意见反馈': '意见反馈',
    '修改密码': '修改密码',
    '修改绑定手机号': '修改绑定手机号',
    '修改绑定邮箱': '修改绑定邮箱',
    '头像': '头像',
    '手机号': '手机号',
    '昵称': '昵称',
    '性别': '性别',
    '保密': '保密',
    '男': '男',
    '女': '女',
    '保存': '保存',
    '完成': '完成',
    '旧密码': '旧密码',
    '新密码': '新密码',
    '6~12位英文+数字的密码': '6~12位英文+数字的密码',
    '确认新密码': '确认新密码',
    '验证码': '验证码',
    '新手机号': '新手机号',
    '新手机号验证码': '新手机号验证码',
    '获取验证码': '获取验证码',
    '我们要对您绑定的手机号进行验证': '我们要对您绑定的手机号进行验证',
    '我们要对您绑定的邮箱进行验证': '我们要对您绑定的邮箱进行验证',
    '新邮箱': '新邮箱',
    '新邮箱验证码': '新邮箱验证码',
    '邮箱': '邮箱',
    '反馈类型': '反馈类型',
    '产品建议': '产品建议',
    '功能故障': '功能故障',
    '其他问题': '其他问题',
    '问题描述': '问题描述',
    '问题描述的越详细，有助于我们更快的解决问题~': '问题描述的越详细，有助于我们更快的解决问题~',
    '请上传应用截图，': '请上传应用截图，',
    '最多上传6张': '最多上传6张',
    '提交反馈': '提交反馈',
    '反馈记录': '反馈记录',
    '反馈类型：': '反馈类型：',
    '反馈时间：': '反馈时间：',
    '平台回复：': '平台回复：',
    '请上传': '请上传',
    '反馈图片': '反馈图片',
    '每': '每',
    '季': '季',
    '半年': '半年',
    '全部下载': '全部下载',
    '确认协议并支付': '确认协议并支付',
    '订阅前请阅读': '订阅前请阅读',
    '订阅协议': '订阅协议',
    '特权对比': '特权对比',
    '普通用户': '普通用户',
    '订阅特权': '订阅特权',
    '每条数据下载都需要付费': '每条数据下载都需要付费',
    '订阅时间内可下载任何数据': '订阅时间内可下载任何数据',
    '到期': '到期',
    '文件大小超出10MB限制, 请压缩或降低文件质量': '文件大小超出10MB限制, 请压缩或降低文件质量'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js